/** Build Jira browse URL for an issue key. */
export function jiraBrowseUrl(
  jiraUrl: string | null | undefined,
  ticketKey: string
): string | null {
  if (!jiraUrl || !ticketKey) return null;
  const base = jiraUrl.replace(/\/$/, '');
  return `${base}/browse/${ticketKey}`;
}

export async function copyJiraLink(
  jiraUrl: string | null | undefined,
  ticketKey: string
): Promise<boolean> {
  const url = jiraBrowseUrl(jiraUrl, ticketKey);
  if (!url) return false;
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
